import FilterRow from './FilterRow';
import { observable, action, makeObservable } from 'mobx';
import _ from 'lodash';

class InequalityFilterRow extends FilterRow {
  value;
  range = {
    lower_bound: null,
    upper_bound: null
  };

  constructor(other) {
    super();

    makeObservable(this, {
      value: observable,
      range: observable,
      updateValue: action,
      updateRangeLowerBound: action,
      updateRangeUpperBound: action
    });

    this.merge(other);
  }

  _afterMerge() {
    if (_.isEmpty(this.values)) return;

    if (this.operator === 'between') {
      this.updateRangeLowerBound(this.values.lowerBound);
      this.updateRangeUpperBound(this.values.upperBound);
    } else {
      this.updateValue(this.values);
    }

    this.values = null;
  }

  updateValue(value) {
    this.value = this.parseValue(value);
  }

  updateRangeLowerBound(value) {
    this.range.lower_bound = this.parseValue(value);
  }

  updateRangeUpperBound(value) {
    this.range.upper_bound = this.parseValue(value);
  }

  toJS() {
    const json = super.toJS();
    return [{
      attribute: json.attribute,
      operator: json.operator,
      values: this.operator === 'between' ? json.range : json.value
    }];
  }
}

export default InequalityFilterRow;
